import { render, staticRenderFns } from "./external-upload-metadata.vue?vue&type=template&id=25dafabc&scoped=true&"
import script from "./external-upload-metadata.vue?vue&type=script&lang=js&"
export * from "./external-upload-metadata.vue?vue&type=script&lang=js&"
import style0 from "./external-upload-metadata.vue?vue&type=style&index=0&id=25dafabc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dafabc",
  null
  
)

export default component.exports